const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_app/$lang/$family/$slug/draft.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
const $$splitLoaderImporter = () => import('/app/apps/web/src/routes/_app/$lang/$family/$slug/draft.tsx?tsr-split=loader');
import { lazyFn } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { buildFeaturePageHead } from "@/features/feature-page/feature-page-head";
import { parseArtistDirectorySearch } from "@/features/feature-page/parseArtistDirectorySearch";
import { PRIVATE_PAGE_ROBOTS } from "@/lib/seo-meta";
import { requireAdmin } from "@/routes/_app/guards";
export const Route = createFileRoute("/_app/$lang/$family/$slug/draft")({
  validateSearch: parseArtistDirectorySearch,
  beforeLoad: ({
    context: {
      queryClient
    },
    location
  }) => requireAdmin({
    queryClient,
    location
  }),
  loader: lazyFn($$splitLoaderImporter, 'loader'),
  head: ({
    loaderData
  }) => buildFeaturePageHead(loaderData?.page, {
    robots: PRIVATE_PAGE_ROBOTS
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});